import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddProductLineItemPage} from '../product-line-items/pages/AddPage'
import {EditPage as EditProductLineItemPage} from '../product-line-items/pages/EditPage'

import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";

export const ProductsLayout = () => {


    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListProducts}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetProduct}>
                    <EditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/product-line-items/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateProductLineItem}>
                    <AddProductLineItemPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/product-line-items/:productLineItemId'
                element={<RestrictedRouteElement rbacAction={rbacActions.UpdateProductLineItem}>
                    <EditProductLineItemPage/></RestrictedRouteElement>}
            />

        </Routes>
    );
};
